export default __webpack_public_path__ + "static/media/873.8f8f85a0.png";